import React, { useState } from "react";
import { contact } from "../data/data";
import "./Contact.css";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    bot: false
  });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const validate = () => {
    if (!form.name.trim() || !form.email.trim() || !form.message.trim())
      return false;
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) return false;
    if (!form.bot) return false;
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      setStatus("error");
      return;
    }
    setLoading(true);
    try {
      await fetch(contact.webhook, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          phone: form.phone,
          message: form.message
        })
      });
      setStatus("success");
      setForm({ name: "", email: "", phone: "", message: "", bot: false });
    } catch {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact" id="contact">
      <h2>{contact.heading}</h2>
      <p className="contact-subheading">{contact.subheading}</p>
      <form className="contact-form" onSubmit={handleSubmit} autoComplete="off">
        <label>
          {contact.nameLabel}
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          {contact.emailLabel}
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          {contact.phoneLabel}
          <input
            type="tel"
            name="phone"
            value={form.phone}
            onChange={handleChange}
          />
        </label>
        <label>
          {contact.messageLabel}
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            required
            rows={4}
          />
        </label>
        <label className="contact-bot">
          <input
            type="checkbox"
            name="bot"
            checked={form.bot}
            onChange={handleChange}
            required
          />
          {contact.botProtection}
        </label>
        <button type="submit" disabled={loading}>
          {contact.submitLabel}
        </button>
        {status === "success" && (
          <div className="contact-success">{contact.successMessage}</div>
        )}
        {status === "error" && (
          <div className="contact-error">{contact.errorMessage}</div>
        )}
      </form>
    </section>
  );
};

export default Contact;
